import './image-background-section.scss'

const CLASS_NAME = `image-background-section`

export type ImageBackgroundSectionProps = {
  className?: string
  backgroundUrl: string
  children?: React.ReactNode
}

export const ImageBackgroundSection = ({
  className,
  children,
  backgroundUrl,
}: ImageBackgroundSectionProps) => {
  return (
    <div
      style={{ backgroundImage: `url(${backgroundUrl}` }}
      className={`${CLASS_NAME} ${className}`}>
      {children}
    </div>
  )
}
